import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gp-panel" }
const _hoisted_2 = { class: "gp-body" }
const _hoisted_3 = { class: "gp-leagues" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "gp-league-name" }
const _hoisted_6 = { class: "gp-matches" }
const _hoisted_7 = { class: "gp-league-title" }
const _hoisted_8 = { class: "gp-grid" }
const _hoisted_9 = {
  key: 0,
  class: "gp-date"
}
const _hoisted_10 = { class: "gp-teams" }
const _hoisted_11 = { class: "gp-team" }
const _hoisted_12 = { class: "gp-team" }
const _hoisted_13 = { class: "gp-actions" }
const _hoisted_14 = {
  key: 0,
  class: "gp-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionsCell = _resolveComponent("ActionsCell")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLeagues, (lg) => {
          return (_openBlock(), _createElementBlock("button", {
            key: lg.id,
            class: _normalizeClass(["gp-league", { active: lg.id === _ctx.activeLeagueId }]),
            onClick: ($event: any) => (_ctx.activeLeagueId = lg.id),
            type: "button"
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(lg.name), 1)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("main", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.activeLeague?.name || ''), 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leagueItems, (g) => {
            return (_openBlock(), _createElementBlock("div", {
              key: g[_ctx.mapping.PrimaryKey],
              class: "gp-card"
            }, [
              (g.gameDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(g.gameTimeMinutes?g.gameTimeMinutes+"'":_ctx.shortDate(g.gameDate)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(g.homeTeamName), 1),
                  _createElementVNode("span", null, _toDisplayString(g.gameTimeMinutes?g.homeTeamGoals:""), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(g.awayTeamName), 1),
                  _createElementVNode("span", null, _toDisplayString(g.gameTimeMinutes?g.awayTeamGoals:""), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_ActionsCell, {
                  mapping: _ctx.mapping,
                  item: g,
                  "route-key": _ctx.routeKey,
                  onOpenModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-modal', $event))),
                  onDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', $event))),
                  onRowAction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('row-action', $event)))
                }, null, 8, ["mapping", "item", "route-key"])
              ])
            ]))
          }), 128)),
          (_ctx.leagueItems.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "No matches"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}